import React from "react";
import {Modal} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import QuoteForm from "./QuoteForm";
import RequestCallback from "./RequestCallback";


const CustomModal= ({ show, onClose, title, contentType, openModal }) => {

    const renderContent = () => {
        switch (contentType) {
            case "form-quote":
                return <QuoteForm openModal={openModal} />;
            case "image-iso":
                return (
                    <LazyLoadImage
                        src="https://res.cloudinary.com/dbirahuue/image/upload/v1759166735/ISO-Certificate-VibhaEnterprises_qa6iyy.webp"
                        alt="ISO_Certification"
                        className="img-fluid"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                        }}
                    />
                );
            case "form-callback":
                return <RequestCallback openModal={openModal} />
            default:
                return <p>No content provided.</p>;
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered dialogClassName="custom-modal" unmountOnExit>
            <Modal.Header closeButton className="py-2">
                <Modal.Title as="h5" style={{fontFamily: "Merriweather, serif"}}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">{renderContent()}</Modal.Body>
        </Modal>
    );
}

export default CustomModal;
